import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '@/providers/AuthProvider';

export function useIsAuthorized() {
  const authService = useContext(AuthContext);

  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    setIsAuthorized(authService.isAuth());
  }, [authService.isAuth()]);

  return isAuthorized;
}
